const service = ((d) => {
  // Show the alert message
  const show = (id, message) => {
    let alert = d.getElementById(id);
    if (alert) {
      alert.style.display = "block";
      alert.getElementsByClassName("alert-message-text")[0].innerHTML = message;
      alert.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Hide the alert message
  const hide = (id) => {
    let alert = d.getElementById(id);
    if (alert) {
      alert.style.display = "none";
      alert.getElementsByClassName("alert-message-text")[0].innerHTML = "";
    }
  };

  return { show, hide };
})(document);

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/alert-message.js